import { render, staticRenderFns } from "./DisqualifyCandidateButton.vue?vue&type=template&id=0803d340&"
import script from "./DisqualifyCandidateButton.vue?vue&type=script&lang=js&"
export * from "./DisqualifyCandidateButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports